import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import { ModuleRegistry, CommunityFeaturesModule } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { LicenseManager } from '@ag-grid-enterprise/core';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { MasterDetailModule } from '@ag-grid-enterprise/master-detail';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { AdvancedFilterModule } from '@ag-grid-enterprise/advanced-filter';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';

ModuleRegistry.registerModules([
  CommunityFeaturesModule,
  ClientSideRowModelModule,
  ServerSideRowModelModule,
  MasterDetailModule,
  ClipboardModule,
  RangeSelectionModule,
  RowGroupingModule,
  AdvancedFilterModule,
  MenuModule,
  StatusBarModule,
]);

const licenceKey = process.env['REACT_APP_AG_GRID_LICENSE'];
if (licenceKey) {
  LicenseManager.setLicenseKey(licenceKey);
}
